import { ClientEnvironment, FooterNavigation } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';

const year = new Date().getFullYear();

export const lufthansaFooterConfig = (env?: ClientEnvironment): FooterNavigation[] => {
  return [
    {
      navLink: [''],
      navText: env?.brandingKey === CustomClients.LufthansaMediacenter ? `&copy; ${year} Lufthansa Technik AG` : `&copy; ${year} Deutsche Lufthansa AG`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.imprintUrl ?? '/content/imprint'],
      navText: $localize`:footer navigation:Imprint`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.contactUrl ?? '/content/contact'],
      navText: $localize`:footer navigation:Contact`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.supportUrl ?? '/content/support'],
      navText: $localize`:footer navigation:Help & Support`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.privacyUrl ?? '/content/data-protection'],
      navText: $localize`:footer navigation:Data Protection`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.termsUrl ?? '/content/terms-of-use'],
      navText: $localize`:footer navigation:Terms of Use`,
    },
  ];
};
